

































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';

    class Editapplyreturn {
        id: number;
        shipment: string;
        reMark: string;
            //recipientInfo: string;
        phone: string;
        receiptAddress: string;
        receiptPhone: string;
        recipientName: string;
        orderType: number;
    }
    @Component
    export default class CreateapplyreturnModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        applyreturn: Editapplyreturn = new Editapplyreturn();
        warehouseOrderType = Enums.WarehouseOrderType;
        created() {
        }
        submit() {
            this.save();
        }
        save() {
            //this.applyreturn.handleType = Enums.HandleStatus.filter(function (item) { return item.value == 2 })[0].value;
            (this.$refs.applyreturnCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'frontorderreturn/createOrderReturn',
                        data: this.applyreturn
                    });
                    (this.$refs.applyreturnCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }

        cancel() {
            (this.$refs.applyreturnCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                (this.$refs.applyreturnCreateForm as any).resetFields();
                var data = this.$store.state.frontorderreturn.orderReturnInfo;
                if (data.id > 0) {
                    this.applyreturn = { id: data.id, phone: "", reMark: "", receiptAddress: "", receiptPhone: "", recipientName: "", shipment: data.orderNumber, orderType:0};
                }
            }
        }

        applyreturnRule = {
            reMark: [
                { max: 500, message: '长度不能大于500', trigger: 'blur' }
            ],
            recipientName: [
                { required: true, max: 500, message: '收件人姓名不能为空', trigger: 'blur' }
            ],
            receiptAddress: [
                { required: true, max: 500, message: '收货地址不能为空', trigger: 'blur' }
            ],
            shipment: [
                { required: true, max: 500, message: '单号不能为空', trigger: 'blur' }
            ],
            phone: [
                { required: false, message: this.L('手机号码不能为空'), trigger: 'blur' },
                { pattern: /^1[0-9]{10}$/, message: this.L('请输入正确手机号码'), trigger: 'blur' }
            ],
            receiptPhone: [
                { required: false, message: this.L('手机号码不能为空'), trigger: 'blur' },
                { pattern: /^(\d{3,4}-)?\d{6,8}$/, message: this.L('请输入正确号码,为6-8位的座机号码'), trigger: 'blur' }
            ],
        };
    }
